module.exports = __webpack_public_path__ + "images/interview-Guidehouse-2.svg";